export default "__VITE_ASSET__CymDBil___"